import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Router from 'root/router';
import Util from 'root/module/util';
import Modals from 'root/modals';
import Svg_Icon from 'root/module/svg_icon';
import Form from 'root/module/form';
import View from 'view/base';
import View_Theme from 'view/portal/theme';
import View_Profile from 'view/portal/profile';
import View_Roadmap_Column from 'view/portal/roadmap_column';
import View_Announcement_Preview from 'view/portal/announcement_preview';
import View_Tags from 'view/portal/tags';
import View_Filters from 'view/portal/filters';
import View_New_Idea from 'view/portal/new_idea';
import View_New_Announcement from 'view/portal/new_announcement';
import View_Feedback_Preview from 'view/portal/feedback_preview';
import View_Feedback_Details from 'view/portal/feedback_details';

export default View.extend({
    xhr: null,
    timeout: null,

    // load params
    load_page: 0,
    load_page_size: 20,
    is_all_loaded: false,

    // load params
    announcement_load_page: 0,
    announcement_load_page_size: 20,
    is_announcement_all_loaded: false,

    roadmap_load_count: 0, // how many roadmap columns have been loaded?

    // filter params
    sort_by: 'date', // date, vote, trending
    status_ids: [],
    categories: [],
    search: '',

    feedback_id: 0,

    portal_url: '',

    page: 'index', // index, roadmap, announcement

    views: {
        profile: {},
        tags: {},
        filters: {},
        feedback_preview: {},
        feedback_details: {},
        new_idea: {},
        theme: {},
        roadmap_column: {},
        new_announcement: {},
        announcement_preview: {},
    },

    events: {
        'click .new-idea'          : 'onNewIdea',
        'click .reset-search'      : 'onResetSearch',
        'click form.search .clear' : 'onClearSearch',
        'click .menu-bar'          : 'onOpenMobileMenu',
        'submit form.search'       : 'onSubmitSearch',
        'click .new-announcement'  : 'onNewAnnouncement',
        'click .back-to-top'       : 'backToTop'
    },

    dom_handlers: {
        onOpenMobileMenu: function() {
            this.$el.find('.nav-mobile').toggle();
        },

        onNewIdea: function(e) {
            e.preventDefault();

            if (!Cache.real_user_id && !Cache.portal_user && !Cache.guest_user) {
                Modals.portalGuest();
                return;
            }

            var location = window.location.pathname + window.location.search;

            this.newFeedback(function() {
                Router.navigate(location, {trigger: false});
            });

            Router.navigate(this.portal_url + '/idea/new' + window.location.search, {trigger: false});
        },

        onNewAnnouncement: function(e) {
            e.preventDefault();

            var location = window.location.pathname + window.location.search;

            this.newAnnouncement(() => {
                Router.navigate(location, {trigger: false});
                this.views.tags.renderAnnouncementCategories();
            });

            Router.navigate(this.portal_url + '/announcement/new' + window.location.search, {trigger: false});
        },

        onScrollFeedback: function(e) {
            if (this.xhr || this.is_all_loaded) {
                return;
            }

            var is_in_viewport = this.$el.find('.feedback-loadmore').get(0).getBoundingClientRect().top <= $(window).height();

            if (is_in_viewport) {
                this.$el.find('.feedback-loadmore').addClass('active');

                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.loadFeedback();
                }, 1000);
            }
        },

        onScrollAnnouncement: function(e) {
            var top = this.$el.find('.main').get(0).scrollTop;

            this.$el.find('.back-to-top').toggleClass('active', top > 0);

            if (this.announcementXhr || this.is_announcement_all_loaded) {
                return;
            }

            var is_in_viewport = this.$el.find('.announcement-loadmore').get(0).getBoundingClientRect().top <= $(window).height();

            if (is_in_viewport) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.loadAnnouncement();
                }, 1000);
            }
        },

        onSubmitSearch: function(e) {
            e.preventDefault();

            this.search = Form.getData(this.$el.find('.search')).search;

            if (this.search) {
                Router.addQueryString('search', this.search);
            } else {
                Router.removeQueryString('search');
            }

            this.$el.find('form.search .clear').toggle(this.search !== '');

            if (this.page === 'index') {
                this.loadFeedback(true);

                this.views.tags.setOptions({
                    search: this.search
                });
                this.views.tags.render();
            } else if (this.page === 'roadmap') {
                this.resetRoadmap();
            } else if (this.page === 'announcement') {
                this.loadAnnouncement(true);
            }
        },

        onClearSearch: function(e) {
            Form.setData(this.$el.find('form.search'), {
                search: ''
            });

            this.$el.find('form.search .clear').hide();
            this.$el.find('form.search').submit();
        },

        onResetSearch: function(e) {
            e.preventDefault();

            this.search     = '';
            this.status_ids = [];
            this.categories = [];

            Form.setData(this.$el.find('form.search'), {
                search: ''
            });

            Router.removeQueryString(['status', 'categories', 'search']);

            if (this.page === 'index') {
                this.loadFeedback(true);

                this.views.tags.setOptions({
                    status_ids : [],
                    categories : [],
                    search     : ''
                });
                this.views.tags.render();
            } else if (this.page === 'roadmap') {
                this.resetRoadmap();
            } else if (this.page === 'announcement') {
                this.loadAnnouncement(true);
            }
        },
        backToTop: function() {
            this.$el.find('.main').get(0).scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        },
    },

    event_handlers: {
        onFeedbackAdd: function(model) {
            this.createFeedbackView(model);
        },

        onFeedbackRemove: function(model) {
            if (typeof this.views.feedback_preview['_' + model.id] !== 'undefined') {
                this.views.feedback_preview['_' + model.id].remove();
                delete this.views.feedback_preview['_' + model.id];

                if (Cache.feedback.length === 0) {
                    this.$el.find('.feedback-empty').show();
                    this.$el.find('.filters').hide();
                }
            }
        },

        onAnnouncementAdd: function(model) {
            this.createAnnouncementView(model);
        },

        onAnnouncementChange: function() {
            this.views.tags.renderAnnouncementCategories();
        },

        onAnnouncementRemove: function(model) {
            if (typeof this.views.announcement_preview['_' + model.id] !== 'undefined') {
                this.views.announcement_preview['_' + model.id].remove();
                delete this.views.announcement_preview['_' + model.id];

                if (Cache.portal_announcement.length === 0) {
                    this.$el.find('.search-result-empty').show();
                }
            }

            this.views.tags.renderAnnouncementCategories();
        },

        onFeedbackOpen: function(payload) {
            var location = window.location.pathname + window.location.search;

            this.openFeedback(payload.model.id, function() {
                Router.navigate(location, {trigger: false});
            });

            if (this.page === 'index') {
                Router.navigate(this.portal_url + '/idea/' + payload.model.id + this.portal_url_params, {trigger: false});
            } else if (this.page === 'roadmap') {
                Router.navigate(this.portal_url + '/roadmap/' + payload.model.id + this.portal_url_params, {trigger: false});
            }
        },

        onSortByChange: function(sort_by) {
            if (this.sort_by === sort_by) {
                return;
            }

            Router.addQueryString('sort_by', sort_by);

            this.sort_by = sort_by;

            if (this.page === 'index') {
                this.loadFeedback(true);
            } else if (this.page === 'roadmap') {
                this.resetRoadmap();
            } else if (this.page === 'announcement') {
                this.loadAnnouncement(true);
            }
        },

        // roadmap embed mode only
        onStatusChange: function(status_model) {
            if (this.page !== 'roadmap' || this.embed !== 'widget') {
                return;
            }

            _.each(this.views.roadmap_column, (view, index) => {
                if ('_' + status_model.id === index) {
                    view.show();
                } else {
                    view.hide();
                }
            });
        },

        onCategoriesChange: function(categories) {
            this.categories = categories;

            Router.addQueryString('categories', categories.join(','));

            if (this.page === 'announcement') {
                this.loadAnnouncement(true);
            } else {
                this.loadFeedback(true);
            }
        },

        onTagChange: function(status_ids, categories) {
            var to_remove = [];
            var to_add    = {};

            if (status_ids && status_ids.length) {
                to_add['status'] = status_ids.join(',');
            } else {
                to_remove.push('status');
            }

            if (categories && categories.length) {
                to_add['categories'] = categories.join(',');
            } else {
                to_remove.push('categories');
            }

            Router.addMultipleQueryString(to_add);
            Router.removeQueryString(to_remove);

            this.categories = categories;

            if (this.page === 'announcement') {
                this.loadAnnouncement(true);
            } else {
                this.loadFeedback(true);
            }
        },

        roadmapLoadFinish: function(portal_status) {
            this.roadmap_load_count++;

            if (this.roadmap_load_count === _.size(this.views.roadmap_column)) {
                if (this.feedback_id && Util.isNumeric(this.feedback_id)) {
                    this.openFeedback(this.feedback_id, () => {
                        Router.navigate(this.portal_url + '/roadmap' + this.portal_url_params, {trigger: false});
                    });
                }
            }
        },

        onMessage: function(event) {
            if (!event.data || !event.data.action) {
                return;
            }

            switch (event.data.action) {
                case 'navigate':
                    if (typeof event.data.component === 'string') {
                        this.$el.find('.header .links a[data-val="' + event.data.component + '"]').click();
                    }
                    return;
            }
        }
    },

    initialize: function(options) {
        if (!Cache.portal || !Cache.portal.length) {
            this.views.theme = new View_Theme({
                colour: '#6042EC'
            });
            return;
        }

        var query_string = Router.getQueryString();

        this.unsubscribe_key   = query_string.u;
        this.unsubscribe_email = query_string.ue;

        this.embed = Router.getQueryString('embed');
        this.guest_login = Router.getQueryString('gl');

        this.portal = Cache.portal.at(0);
        this.portal_url = '/p/' + this.portal.get('portal_key');
        this.portal_url_params = []; // always keeps these "critial" URL params in the URL because backend needs them

        if (this.embed) {
            this.portal_url_params.push('embed=' + encodeURIComponent(this.embed));
        }

        if (this.guest_login) {
            this.portal_url_params.push('gl=' + encodeURIComponent(this.guest_login));

            // guest user is
            // 1) set in session in backend, or
            // 2) set here when it is passed via URL ?gl=xxxx because session won't work when portal is embedded cross domain

            try {
                var guest_data = JSON.parse(atob(this.guest_login));
                if (guest_data.email && guest_data.name && Util.isValidEmail(guest_data.email)) {
                    Cache.setGuestUser(guest_data.email, guest_data.name, '', 'portal_guest');
                } else {
                    // validation error
                }
            } catch (e) {
                // parse error
            }
        }

        if (this.embed === 'widget' && !this.guest_login) {
            // show a special UI to inform people?
        }

        this.portal_url_params = this.portal_url_params.length ? '?' + this.portal_url_params.join('&') : '';

        if (options) {
            if (options.password_reset_key) {
                this.password_reset_key = options.password_reset_key;
            }

            if (options.feedback_id) {
                if (Util.isNumeric(options.feedback_id)) {
                    this.feedback_id = parseInt(options.feedback_id)
                } else if (options.feedback_id === 'new') {
                    this.feedback_id = 'new';
                }
            }

            if (options.roadmap && this.portal.get('has_roadmap')) {
                this.page = 'roadmap';
            }

            if (options.announcement && this.portal.get('has_announcement')) {
                this.page = 'announcement';
            }
        }

        // TODO
        // if (!this.portal.get('has_feature_requests')) {
        //     this.page = 'roadmap';
        // }

        if (!this.portal.get('has_feature_requests') && !this.portal.get('has_roadmap') && !this.portal.get('has_announcement')) {
            this.page = 'portal_off';
        }

        this.sort_by    = this.page === 'announcement' ? 'DESC' : 'date';
        this.status_ids = [];
        this.categories = [];
        this.search     = '';

        if (['date', 'vote', 'trending'].indexOf(query_string.sort_by) !== -1) {
            this.sort_by = query_string.sort_by;
        }

        if (query_string.search) {
            this.search = query_string.search;
        }

        if (query_string.status) {
            this.status_ids = query_string.status.split(',');
        }

        if (query_string.categories) {
            this.categories = query_string.categories.split(',');
        }

        // validate
        this.status_ids.forEach((val, index) => {
            if (Cache.portal_status.get(val)) {
                this.status_ids[index] = parseInt(val, 10);
            } else {
                this.status_ids.splice(index, 1);
            }
        });

        this.categories.forEach((val, index) => {
            if (!Cache.feedback_category.findWhere({name: val})) {
                this.categories.splice(index, 1);
            }
        });

        // create views
        this.views.profile = new View_Profile({
            portal: this.portal
        });
        this.views.tags    = new View_Tags({
            status_ids : this.page == 'announcement' ? undefined : this.status_ids,
            categories : this.categories,
            search     : this.search,
            page       : this.page
        });
        this.views.filters = new View_Filters({
            mode       : this.page,
            sort_by    : this.sort_by,
            categories : this.categories,
            embed      : this.embed
        });
        this.views.theme = new View_Theme({
            colour: this.portal.get('theme_colour')
        });

        if (this.page === 'roadmap') {
            Cache.portal_status.each((model) => {
                this.views.roadmap_column['_' + model.id] = new View_Roadmap_Column({
                    model      : model,
                    sort_by    : this.sort_by,
                    categories : this.categories,
                    search     : this.search
                });

                this.listenTo(this.views.roadmap_column['_' + model.id], 'loadFinish', this.event_handlers.roadmapLoadFinish);
            });
        }

        if (this.page === 'announcement') {
            Cache.portal_announcement.forEach((model) => {
                this.views.announcement_preview['_' + model.id] = new View_Announcement_Preview({
                    model: model,
                    embed: this.embed,
                });
            });

            this.announcement_load_page = Math.ceil(Cache.portal_announcement.length / this.load_page_size)
        }

        // bind events
        this.listenTo(this.views.filters, 'change:sort_by',    this.event_handlers.onSortByChange);
        this.listenTo(this.views.filters, 'chagne:status',     this.event_handlers.onStatusChange);
        this.listenTo(this.views.filters, 'change:categories', this.event_handlers.onCategoriesChange);

        if (this.page === 'index') {
            this.listenTo(Cache.feedback,     'add',        this.event_handlers.onFeedbackAdd);
            this.listenTo(Cache.feedback,     'remove',     this.event_handlers.onFeedbackRemove);
        }

        if (this.page === 'announcement') {
            this.listenTo(Cache.portal_announcement,     'add',     this.event_handlers.onAnnouncementAdd);
            this.listenTo(Cache.portal_announcement,     'change',     this.event_handlers.onAnnouncementChange);
            this.listenTo(Cache.portal_announcement,     'remove',     this.event_handlers.onAnnouncementRemove);
        }

        if (this.page === 'index' || this.page === 'announcement') {
            this.listenTo(this.views.tags,    'change:tag', this.event_handlers.onTagChange);
        }

        this.on('remove', function() {
            this.resetFeedabck();
            Cache.app.dispatcher.off('Portal::Feedback::View');
        });

        Cache.app.dispatcher.on('Portal::Feedback::View', this.event_handlers.onFeedbackOpen.bind(this));
    },

    createAnnouncementView: function(model) {
        this.views.announcement_preview['_' + model.id] = new View_Announcement_Preview({
            model: model,
            embed: this.embed,
        });

        this.views.announcement_preview['_' + model.id].render().$el.appendTo(this.$el.find('.region-announcements'));

        return this.views.announcement_preview['_' + model.id];
    },

    createFeedbackView: function(model) {
        this.views.feedback_preview['_' + model.id] = new View_Feedback_Preview({
            model: model,
            mode: 'preview'
        });

        this.views.feedback_preview['_' + model.id].render().$el.appendTo(this.$el.find('.region-feedback'));

        return this.views.feedback_preview['_' + model.id];
    },

    resetRoadmap: function() {
        Cache.feedback_comment.remove(Cache.feedback_comment.models);
        Cache.feedback_screenshot.remove(Cache.feedback_screenshot.models);
        Cache.feedback.remove(Cache.feedback.models);

        _.each(this.views.roadmap_column, function(view) {
            view.reset({
                sort_by    : this.sort_by,
                categories : this.categories,
                search     : this.search
            });
        }, this);
    },

    resetFeedabck: function() {
        this.load_page = 0;
        this.is_all_loaded = false;

        Cache.feedback_comment.remove(Cache.feedback_comment.models);
        Cache.feedback_screenshot.remove(Cache.feedback_screenshot.models);
        Cache.feedback.remove(Cache.feedback.models);
    },

    loadFeedback: function(reset, on_success) {
        if (this.page !== 'index') {
            return;
        }

        if (this.xhr) {
            // loading in progress
            return;
        }

        if (reset) {
            this.resetFeedabck();
            this.renderFeedbackPlaceholder();
        }

        this.load_page++;

        this.xhr = Cache.app.request({
            action: 'portal/loadFeedback',
            context: this,
            data: {
                page         : this.load_page,
                page_size    : this.load_page_size,
                sort_by      : this.sort_by,
                status_ids   : this.status_ids,
                categories   : this.categories,
                search       : this.search
            },
            success: function(response) {
                this.$el.find('.init-placeholder').remove();

                Cache.feedback_comment.add(response.feedback_comment);
                Cache.feedback_screenshot.add(response.feedback_screenshot);
                Cache.feedback.add(response.feedback);

                if (response.feedback.length < this.load_page_size) {
                    this.is_all_loaded = true;
                }

                if (Cache.feedback.length === 0) {
                    this.$el.find('.feedback-empty').show();
                }

                if (on_success) {
                    on_success();
                }
            },
            complete: function() {
                this.xhr = null;
                this.$el.find('.feedback-loadmore').removeClass('active');
            }
        });
    },

    resetAnnouncement: function() {
        this.announcement_load_page = 0;
        this.is_announcement_all_loaded = false;

        Cache.portal_announcement.remove(Cache.portal_announcement.models);
    },

    renderAnnouncemnetPlaceholder: function() {
        this.$el.find('.announcement-empty').hide();
    },

    loadAnnouncement: function(reset, on_success) {
        if (this.page !== 'announcement') {
            return;
        }

        if (this.announcementXhr) {
            return;
        }

        if (reset) {
            this.resetAnnouncement();
            this.renderAnnouncemnetPlaceholder();
        }

        this.announcement_load_page++;

        this.$el.find('.announcement-loadmore').addClass('active');

        this.announcementXhr = Cache.app.request({
            action: 'portal/loadAnnouncement',
            data: {
                page         : this.announcement_load_page,
                page_size    : this.announcement_load_page_size,
                categories   : this.categories,
                sort_by      : this.sort_by,
                search       : this.search
            },
            success: (response) => {
                Cache.portal_announcement.add(response.announcement);

                if (response.announcement.length < this.load_page_size) {
                    this.is_announcement_all_loaded = true;
                }

                if (Cache.portal_announcement.length === 0) {
                    this.$el.find('.search-result-empty').show();
                }

                if (on_success) {
                    on_success();
                }
            },
            complete: () => {
                this.announcementXhr = null;
                this.$el.find('.announcement-loadmore').removeClass('active');
            }
        });
    },

    openFeedback: function(feedback_id, on_close) {
        this.feedback_id = feedback_id;

        this.views.feedback_details = new View_Feedback_Details({
            embed: this.embed,
            feedback_id: feedback_id
        });
        this.views.feedback_details.render().$el.appendTo(this.$el);

        this.views.feedback_details.on('close', () => {
            this.views.feedback_details.remove();

            if (on_close) {
                on_close();
            }
        });
    },

    newFeedback: function(on_close, idea_title) {
        this.views.new_idea = new View_New_Idea({
            embed: this.embed,
            idea_title: idea_title
        });
        this.views.new_idea.render().$el.appendTo(this.$el);
        this.views.new_idea.focus();

        this.views.new_idea.on('close', (payload) => {
            this.views.new_idea.remove();
            delete this.views.new_idea;

            if (on_close) {
                on_close();
            }

            if (payload && payload.new_feedback) {
                if (this.portal.get('approve_portal')) {
                    // reset page so the new idea always appears on the top
                    this.resetAllFilters();

                    this.loadFeedback(true, () => {
                        // auto vote new feedback
                        if (this.views.feedback_preview['_' + payload.new_feedback.id]) {
                            this.views.feedback_preview['_' + payload.new_feedback.id].vote();
                        }
                    });
                }
            }
        });

        this.views.new_idea.on('openSuggestion', (feedback_id, idea_title) => {
            this.views.new_idea.remove();
            delete this.views.new_idea;

            this.openFeedback(feedback_id, () => {
                this.newFeedback(undefined, idea_title);
            });
        });
    },

    newAnnouncement: function(on_close) {
        this.views.new_announcement = new View_New_Announcement({});
        this.views.new_announcement.render().$el.appendTo(this.$el);
        this.views.new_announcement.focus();

        this.views.new_announcement.on('close', (payload) => {
            this.views.new_announcement.remove();
            delete this.views.new_announcement;

            if (on_close) {
                on_close();
            }

            if (payload && payload.announcement) {
                this.loadAnnouncement(true);
            }
        });
    },

    onPageReady: function() {
        var query_string = Router.getQueryString();

        if (!this.portal || !this.hasPrivateAccess()) {
            return;
        }

        if (this.feedback_id && this.unsubscribe_key && this.unsubscribe_email) {
            Cache.app.request({
                action: 'feedback/unsubscribe',
                data : {
                    id    : this.feedback_id,
                    key   : this.unsubscribe_key,
                    email : this.unsubscribe_email
                },
                error: function() {
                    // ignore
                }
            });

            return;
        }

        if (this.feedback_id === 'new') {
            this.newFeedback(() => {
                Router.navigate(this.portal_url + this.portal_url_params, {trigger: false});
            });
        } else if (this.password_reset_key) {
            Modals.passwordReset(this.password_reset_key);
        }

        if (this.page === 'index') {
            // load init feedback data
            this.loadFeedback(true, () => {
                if (this.feedback_id && Util.isNumeric(this.feedback_id)) {
                    this.openFeedback(this.feedback_id, () =>  {
                        Router.navigate(this.portal_url + this.portal_url_params, {trigger: false});
                    });
                }
            });

            this.$el.find('.main').on('scroll', this.dom_handlers.onScrollFeedback.bind(this));
        } else if (this.page === 'roadmap') {
            // openFeedback is handled in roadmapLoadFinish
        } else if (this.page === 'announcement') {
            this.$el.find('.main').on('scroll', this.dom_handlers.onScrollAnnouncement.bind(this));
        }

        if (Cache.portal_announcement.length === 0) {
            this.loadAnnouncement(true);
        }

        if (Cache.portal_user) {
            var query_string = Router.getQueryString();

            if (query_string.ec) {
                // email address confirmation
                this.confirmEmail(query_string.ec);
            }
        }

        window.addEventListener('message', this.event_handlers.onMessage.bind(this));
    },

    confirmEmail: function(email_code) {
        Cache.app.request({
            action: 'portal_user/confirmEmail',
            data : {
                key: email_code
            },
            success: function(response) {
                UI.success('Your email address has been verified');
                Cache.portal_user.set('is_email_confirmed', true);

                Router.removeQueryString('ec');
            }
        });
    },

    resetAllFilters: function() {
        this.sort_by    = 'date';
        this.status_ids = [];
        this.categories = [];
        this.search     = '';

        this.views.tags.setOptions({
            status_ids : [],
            categories : [],
            search     : ''
        });
        this.views.tags.render();

        this.views.filters.setOptions({
            sort_by: this.sort_by
        });
        this.views.filters.render();

        Form.setData(this.$el.find('form.search'), {
            search: ''
        });

        Router.removeQueryString(['status', 'categories', 'search', 'sort_by']);
    },

    hasPrivateAccess: function() {
        if (!this.portal) {
            return false;
        }

        if (!this.portal.get('sso_login')) {
            return true;
        }

        // internal user
        if (Cache.real_user_id) {
            return true;
        }

        if (Cache.guest_user && Cache.guest_user.get('type') === 'portal_sso') {
            return true;
        }

        return false;
    },

    renderFeedbackPlaceholder: function() {
        var content =
        '<div class="init-placeholder">' +
            '<div class="loader-placeholder-regular"></div>' +
            '<div>' +
                '<div class="loader-placeholder-medium margin-bottom-16" style="width:70%;"></div>' +
                '<div class="loader-placeholder-medium margin-bottom-16"></div>' +
                '<div class="loader-placeholder-medium margin-bottom-64"></div>' +
            '</div>' +

            '<div class="loader-placeholder-regular"></div>' +
            '<div>' +
                '<div class="loader-placeholder-medium margin-bottom-16" style="width:70%;"></div>' +
                '<div class="loader-placeholder-medium margin-bottom-16"></div>' +
                '<div class="loader-placeholder-medium margin-bottom-64"></div>' +
            '</div>' +
        '</div>';

        this.$el.find('.region-feedback').html(content);

        this.$el.find('.feedback-empty').hide();
        this.$el.find('.filters').show();
    },

    render404: function() {
        var content =
        '<div class="not-found">' +
            '<div>' +
                '<div class="icon"><i class="far fa-eye-slash"></i></div>' +
                '<h2>Oops</h2>' +
                '<div class="text-info">The URL doesn\'t seem to be right</div>' +
                '<div class="divider-48"></div>' +
                '<div class="powered-by">' +
                    '<a href="https://www.userback.io">' +
                        '<span>Powered by</span>' +
                        '<span>' + Svg_Icon.logo_simple +  'Userback</span>' +
                    '</a>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        this.views.theme.render().$el.appendTo(this.$el);
    },

    renderPrivateAccessError: function() {
        var private_access_message = this.portal.getTranslation('private_access').split(/(?:\r\n|\r|\n)/);
        var private_access_heading = private_access_message[0];
        var private_access_body    = private_access_message.slice(1).join('\n');

        var content =
        '<div class="not-found">' +
            '<div>' +
                '<div class="icon"><i class="far fa-eye-slash"></i></div>' +
                '<h2>' + Util.htmlEntities(private_access_heading) + '</h2>' +
                '<div class="text-info">' + Util.htmlEntitiesWithA(private_access_body, true, false) + '</div>' +
                '<div class="divider-48"></div>' +
                '<div class="powered-by">' +
                    '<a href="https://www.userback.io">' +
                        '<span>Powered by</span>' +
                        '<span>' + Svg_Icon.logo_simple +  'Userback</span>' +
                    '</a>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        this.views.theme.render().$el.appendTo(this.$el);
    },

    render: function() {
        var content = '';

        // invalid portal url
        if (!this.portal) {
            this.render404();
            return this;
        }

        // SSO enforcement
        if (!this.hasPrivateAccess()) {
            this.renderPrivateAccessError();
            return this;
        }

        var is_internal_user = Cache.real_user_id && (Cache.app.isAdmin() || Cache.app.isCollaborator());

        if (this.feedback_id && this.unsubscribe_key && this.unsubscribe_email) {
            content += '<div class="not-found">' +
                            '<div>' +
                                '<div class="icon"><i class="far fa-bell-slash"></i></div>' +
                                '<h2>Unsubscribed Successfully!</h2>' +
                                '<div class="text-info">You will no longer receive notifications about this feedback.</div>' +
                                '<div class="powered-by">' +
                                    '<a href="https://www.userback.io">' +
                                        '<span>Powered by</span>' +
                                        '<span>' + Svg_Icon.logo_simple +  'Userback</span>' +
                                    '</a>' +
                                '</div>' +
                            '</div>' +
                        '</div>';

            this.$el.html(content);

            this.views.theme.render().$el.appendTo(this.$el);

            return this;
        }

        content += '<div class="header">' +
                        (this.embed === 'widget' ? '' :
                        '<a href="' + this.portal_url + this.portal_url_params + '" class="logo">' +
                            (this.portal.get('logo') ?
                            '<img src="' + this.portal.get('logo') + '">' :
                            Svg_Icon.logo) +
                        '</a>' ) +

                        (this.portal.get('has_feature_requests') + this.portal.get('has_roadmap') + this.portal.get('has_announcement') > 1 ?

                        '<div class="links">' +
                            (this.portal.get('has_feature_requests') ?
                            '<a href="' + this.portal_url + this.portal_url_params + '" class="navigation' + (this.page === 'index' ? ' active' : '') + '" data-val="portal"><i class="far fa-lightbulb-on"></i>Ideas</a>' : '') +

                            (this.portal.get('has_roadmap') ?
                            '<a href="' + this.portal_url + '/roadmap' + this.portal_url_params + '" class="navigation' + (this.page === 'roadmap' ? ' active' : '') + '" data-val="roadmap"><i class="far fa-analytics"></i>Roadmap</a>' : '') +

                            (this.portal.get('has_announcement') ?
                            '<a href="' + this.portal_url + '/announcement' + this.portal_url_params + '" class="navigation' + (this.page === 'announcement' ? ' active' : '') + '" data-val="announcement"><i class="far fa-bullhorn"></i>Announcements</a>' : '') +
                        '</div>' : '') +

                        '<div class="menu-bar"><i class="fal fa-bars"></i></div>' +

                        (this.embed === 'widget' ? '' :
                        '<form class="search">' +
                            '<input type="text" placeholder="Search" name="search">' +
                            '<div class="clear"><i class="fas fa-times-circle"></i></div>' +
                        '</form>') +
                    '</div>';

        content += '<div class="nav-mobile">' +
                        (this.portal.get('has_feature_requests') ?
                        '<a href="' + this.portal_url + this.portal_url_params + '" class="navigation' + (this.page === 'index' ? ' active' : '') + '"><i class="far fa-fw fa-lightbulb-on"></i>Ideas</a>' : '') +

                        (this.portal.get('has_roadmap') ?
                        '<a href="' + this.portal_url + '/roadmap' + this.portal_url_params + '" class="navigation' + (this.page === 'roadmap' ? ' active' : '') + '"><i class="far fa-fw fa-analytics"></i>Roadmap</a>' : '') +

                        (this.portal.get('has_announcement') ?
                        '<a href="' + this.portal_url + '/announcement' + this.portal_url_params + '" class="navigation' + (this.page === 'announcement' ? ' active' : '') + '"><i class="far fa-bullhorn"></i>Announcements</a>' : '') +
                    '</div>';

        if (this.page === 'index' || this.page === 'announcement') {
            content += '<div class="nav"></div>';

            if (this.page === 'index') {
                content += '<div class="main">' +
                                '<div>' +
                                    '<div class="region-actions">' +
                                        (this.embed === 'widget' ?
                                        '<button type="button" class="new-idea primary small-medium font-weight-semibold"' + (Cache.account.get('is_response_limit_reached') ? ' disabled' : '') + '><i class="far fa-plus"></i> ' + this.portal.getTranslation('new_idea_button') + '</button>' :
                                        '<button type="button" class="new-idea primary medium"' + (Cache.account.get('is_response_limit_reached') ? ' disabled' : '') + '><i class="far fa-plus"></i> ' + this.portal.getTranslation('new_idea_button') + '</button>') +
                                    '</div>' +
                                    '<div class="region-feedback"></div>' +
                                    '<div class="feedback-loadmore loader loader-small"></div>' +
                                    '<div class="feedback-empty search-result-empty">' +
                                        (this.embed ? '' :
                                        '<div class="icon"><i class="fad fa-file-search"></i></div>') +

                                        (this.embed ?
                                        '<h1>We couldn\'t find anything</h1>' : '<h1>We couldn\'t find anything</h1>') +

                                        '<p class="text-info">Try adjusting your search to find what you\'re looking for.</p>' +
                                        '<p><a href="#" class="reset-search primary">Clear search</a> or <a href="#" class="new-idea primary">Submit a new idea</a></p>' +
                                    '</div>' +
                                '</div>' +
                            '</div>';
            } else if (this.page === 'announcement') {
                content += '<div class="main">' +
                                '<div>' +
                                    '<div class="region-actions">' +
                                        (is_internal_user && !this.embed ?
                                        '<button type="button" class="new-announcement primary medium"><i class="far fa-plus"></i> New Announcement</button>' : '') +
                                    '</div>' +
                                    '<div class="region-announcements"></div>' +
                                    '<div class="announcement-loadmore loader loader-small active"></div>' +
                                    '<div class="announcement-empty search-result-empty">' +
                                        (this.embed ? '' :
                                        '<div class="icon"><i class="fad fa-file-search"></i></div>') +
                                        '<h1>No Announcements</h1>' +
                                        '<p class="text-info">Try adjusting your search to find what you\'re looking for.</p>' +
                                        '<p>' +
                                            '<a href="#" class="reset-search primary">Clear search</a>' +
                                            (is_internal_user ?
                                            ' or <a href="#" class="new-announcement primary">Create a new announcement</a>' : '') +
                                        '</p>' +
                                    '</div>' +
                                    '<button class="back-to-top tertiary round small" type="button"><i class="fa-light fa-arrow-up-to-line"></i></button>' +
                                '</div>' +
                            '</div>';
            }

            if (this.portal.get('powered_by')) {
                content += '<div class="powered-by">' +
                                '<a href="https://www.userback.io">' +
                                    '<span>Powered by</span>' +
                                    '<span>' + Svg_Icon.logo_simple +  'Userback</span>' +
                                '</a>' +
                            '</div>';
            }
        } else if (this.page === 'roadmap') {
            content += '<div class="roadmap">' +
                            '<div class="region-actions"></div>' +
                            '<div class="region-columns"></div>' +
                        '</div>';
        } else if (this.page === 'portal_off') {
            content +=
            '<div class="not-found">' +
                '<div>' +
                    '<div class="icon"><i class="far fa-eye-slash"></i></div>' +
                    '<h2>Oops</h2>' +
                    '<div class="text-info">The ideas portal is not turned on</div>' +
                    '<div class="divider-48"></div>' +
                    '<div class="powered-by">' +
                        '<a href="https://www.userback.io">' +
                            '<span>Powered by</span>' +
                            '<span>' + Svg_Icon.logo_simple +  'Userback</span>' +
                        '</a>' +
                    '</div>' +
                '</div>' +
            '</div>';
        }

        this.$el.html(content);

        this.views.profile.render().$el.insertBefore(this.$el.find('.header .search'));

        this.views.theme.render().$el.appendTo(this.$el);

        this.views.filters.render().$el.prependTo(this.$el.find('.region-actions'));

        if (this.page === 'index') {
            this.views.tags.render().$el.appendTo(this.$el.find('.nav'));
        } else if (this.page === 'roadmap') {
            var count = 0;
            _.each(this.views.roadmap_column, (view) => {
                view.render().$el.appendTo(this.$el.find('.region-columns'));

                if (this.embed === 'widget' && count !== 0) {
                    view.hide();
                }

                count++;
            });
        } else if (this.page === 'announcement') {
            this.views.tags.render().$el.appendTo(this.$el.find('.nav'));

            var announcement_previews = Object.keys(this.views.announcement_preview);

            announcement_previews.forEach((key) => {
                this.views.announcement_preview[key].render().$el.appendTo(this.$el.find('.region-announcements'));
            });

            if (announcement_previews.length) {
                this.$el.find('.announcement-loadmore').removeClass('active');
            }
        }

        Form.setData(this.$el.find('form.search'), {
            search: this.search
        });

        if (this.search) {
            this.$el.find('form.search .clear').show();
        }

        if (this.embed) {
            $(document.body).attr('data-embed', this.embed);
        } else {
            $(document.body).removeAttr('data-embed');
        }

        return this;
    }
});